export default __webpack_public_path__ + "static/context-dark-a700880bbe2cdfaa9d286098fc875fe1.png";